"use strict";
/**
 * Static reference data shared between the API and any future frontend:
 * Romanian counties (ISO 3166-2:RO), Bucharest's six sectors (used as the
 * "city" for RO-B addresses instead of a free-text city name), and the UN/CEFACT
 * unit-of-measure codes this app supports for product/line quantities.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUCHAREST_SECTOR_MESSAGE = exports.SUBSCRIPTION_NOTE_VARIABLES = exports.UNIT_CODE_VALUES = exports.UNIT_CODES = exports.BUCHAREST_SECTORS = exports.RO_COUNTY_CODES = exports.RO_COUNTIES = void 0;
exports.unitLabelForCode = unitLabelForCode;
exports.isCountyCityValid = isCountyCityValid;
exports.countyDisplayName = countyDisplayName;
exports.cityDisplayName = cityDisplayName;
exports.RO_COUNTIES = [
    { code: 'RO-B', name: 'București' },
    { code: 'RO-AB', name: 'Alba' },
    { code: 'RO-AR', name: 'Arad' },
    { code: 'RO-AG', name: 'Argeș' },
    { code: 'RO-BC', name: 'Bacău' },
    { code: 'RO-BH', name: 'Bihor' },
    { code: 'RO-BN', name: 'Bistrița-Năsăud' },
    { code: 'RO-BT', name: 'Botoșani' },
    { code: 'RO-BR', name: 'Brăila' },
    { code: 'RO-BV', name: 'Brașov' },
    { code: 'RO-BZ', name: 'Buzău' },
    { code: 'RO-CS', name: 'Caraș-Severin' },
    { code: 'RO-CL', name: 'Călărași' },
    { code: 'RO-CJ', name: 'Cluj' },
    { code: 'RO-CT', name: 'Constanța' },
    { code: 'RO-CV', name: 'Covasna' },
    { code: 'RO-DB', name: 'Dâmbovița' },
    { code: 'RO-DJ', name: 'Dolj' },
    { code: 'RO-GL', name: 'Galați' },
    { code: 'RO-GR', name: 'Giurgiu' },
    { code: 'RO-GJ', name: 'Gorj' },
    { code: 'RO-HR', name: 'Harghita' },
    { code: 'RO-HD', name: 'Hunedoara' },
    { code: 'RO-IL', name: 'Ialomița' },
    { code: 'RO-IS', name: 'Iași' },
    { code: 'RO-IF', name: 'Ilfov' },
    { code: 'RO-MM', name: 'Maramureș' },
    { code: 'RO-MH', name: 'Mehedinți' },
    { code: 'RO-MS', name: 'Mureș' },
    { code: 'RO-NT', name: 'Neamț' },
    { code: 'RO-OT', name: 'Olt' },
    { code: 'RO-PH', name: 'Prahova' },
    { code: 'RO-SM', name: 'Satu Mare' },
    { code: 'RO-SJ', name: 'Sălaj' },
    { code: 'RO-SB', name: 'Sibiu' },
    { code: 'RO-SV', name: 'Suceava' },
    { code: 'RO-TR', name: 'Teleorman' },
    { code: 'RO-TM', name: 'Timiș' },
    { code: 'RO-TL', name: 'Tulcea' },
    { code: 'RO-VS', name: 'Vaslui' },
    { code: 'RO-VL', name: 'Vâlcea' },
    { code: 'RO-VN', name: 'Vrancea' },
];
exports.RO_COUNTY_CODES = exports.RO_COUNTIES.map((county) => county.code);
exports.BUCHAREST_SECTORS = ['SECTOR1', 'SECTOR2', 'SECTOR3', 'SECTOR4', 'SECTOR5', 'SECTOR6'];
exports.UNIT_CODES = [
    { code: 'H87', label: 'buc' },
    { code: 'HUR', label: 'oră' },
    { code: 'DAY', label: 'zi' },
    { code: 'MON', label: 'lună' },
    { code: 'KGM', label: 'kg' },
    { code: 'LTR', label: 'l' },
    { code: 'MTR', label: 'm' },
    { code: 'LS', label: 'serviciu' },
];
exports.UNIT_CODE_VALUES = exports.UNIT_CODES.map((unit) => unit.code);
function unitLabelForCode(code) {
    return exports.UNIT_CODES.find((unit) => unit.code === code)?.label;
}
/**
 * The predefined variables a subscription's invoice-note template may use.
 * Each `token` is substituted with a DD.MM.YYYY date when an invoice is
 * generated (see the API's `note-template.ts` renderer); the calendar-month
 * variables resolve relative to the invoiced period's START. Single source of
 * truth for BOTH the renderer's substitution and the hint list shown next to
 * the note field in the subscription form — so the UI can never advertise a
 * token the renderer does not actually handle (a spec in `note-template.spec.ts`
 * asserts every token here is substituted).
 */
exports.SUBSCRIPTION_NOTE_VARIABLES = [
    { token: '[prima zi a lunii curente]', description: 'prima zi a lunii perioadei facturate' },
    { token: '[ultima zi a lunii curente]', description: 'ultima zi a lunii perioadei facturate' },
    { token: '[prima zi a lunii anterioare]', description: 'prima zi a lunii precedente' },
    { token: '[ultima zi a lunii anterioare]', description: 'ultima zi a lunii precedente' },
    { token: '[prima zi a perioadei]', description: 'data de început a perioadei facturate' },
    { token: '[ultima zi a perioadei]', description: 'data de sfârșit a perioadei facturate' },
];
exports.BUCHAREST_SECTOR_MESSAGE = 'Pentru București, localitatea trebuie să fie un sector (SECTOR1-SECTOR6).';
/**
 * Whether `cityName` is an acceptable value for `countyCode`: non-Bucharest
 * counties accept any city name; RO-B (București) requires one of the six
 * sectors. Shared by firm.schema.ts and client.schema.ts (both create-time
 * zod validation and each service's PATCH-time re-validation against the
 * row merged with the persisted state — a partial payload's schema alone
 * can't see fields it didn't touch).
 */
function isCountyCityValid(countyCode, cityName) {
    return countyCode !== 'RO-B' || exports.BUCHAREST_SECTORS.includes(cityName);
}
/**
 * The human-readable county name for display (e.g. "Cluj" for "RO-CJ") —
 * falls back to the raw code for anything not in `RO_COUNTIES` (should not
 * happen for a persisted row, since `countyCode` is validated against this
 * same list at write time, but a renderer must never throw over it). Shared
 * by both places an invoice's Furnizor/Cumpărător blocks get drawn — the
 * web view (`FacturaViewPage.tsx`) and the PDF (`invoice-template.service.ts`)
 * — specifically so the two renderings of the same document can't drift:
 * one function, one mapping, used by both.
 */
function countyDisplayName(countyCode) {
    return exports.RO_COUNTIES.find((county) => county.code === countyCode)?.name ?? countyCode;
}
/**
 * The human-readable locality for display: for București (`RO-B`), `cityName`
 * is stored as one of `BUCHAREST_SECTORS`'s raw codes ("SECTOR1") — this
 * turns that into "Sector 1", the same label `RO_COUNTIES`-driven county
 * dropdowns already show the user when they pick it (see
 * `apps/web/src/features/firme/FirmaDateFields.tsx`'s `SECTOR_OPTIONS`).
 * Every other county's `cityName` is free text and passes through unchanged.
 */
function cityDisplayName(countyCode, cityName) {
    if (countyCode === 'RO-B' && exports.BUCHAREST_SECTORS.includes(cityName)) {
        return `Sector ${cityName.replace('SECTOR', '')}`;
    }
    return cityName;
}
